<template>
  <aside class="sidebar">
    <!-- Close button (visible only on small screens) -->
    <button class="close-btn" @click="closeSidebar" aria-label="Close sidebar">
      &times; <!-- X icon for close -->
    </button>
    
    <h2 class="sidebar-title">VUE LBD</h2>
    <ul class="sidebar-list">
      <li class="sidebar-item">
        <router-link to="/">
          <i class="fas fa-tachometer-alt"></i> Dashboard
        </router-link>
      </li>
      <li class="sidebar-item">
        <router-link to="/task">
          <i class="fas fa-tasks"></i> Task
        </router-link>
      </li>
      <li class="sidebar-item">
        <router-link to="/pages/profile">
          <i class="fas fa-user"></i> Profile
        </router-link>
      </li>
      <li class="sidebar-item">
        <router-link to="/pages/icons">
          <i class="fas fa-icons"></i> Icons
        </router-link>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  name: 'AppSidebar',
  methods: {
    closeSidebar() {
      // Remove 'sidebar-open' class from body to close sidebar
      document.body.classList.remove('sidebar-open');
    },
  },
};
</script>

<style scoped>
.sidebar {
  background-color: #1f2937;
  color: #ffffff;
  padding: 20px;
  width: 250px;
  height: 100vh; /* Ensures full viewport height */
  position: fixed; /* Keeps sidebar fixed to the left of the screen */
  top: 0;
  left: 0;
  transition: transform 0.3s ease;
  overflow-y: hidden; /* Prevent scrolling within the sidebar */
  z-index: 1000;
  transform: translateX(-100%); /* Hidden by default for small screens */
}

/* Show sidebar when 'sidebar-open' class is added to body */
body.sidebar-open .sidebar {
  transform: translateX(0); /* Slide in the sidebar */
}

/* Close button styling */
.close-btn {
  font-size: 24px;
  color: #ffffff;
  background: none;
  border: none;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

/* Hide the close button on larger screens */
@media (min-width: 768px) {
  .close-btn {
    display: none;
  }
  /* Sidebar is always visible on larger screens */
  .sidebar {
    transform: translateX(0); /* Show sidebar on large screens */
    position: fixed; /* Keeps sidebar fixed for full height */
    height: 100vh; /* Full viewport height on large screens as well */
  }
}

.sidebar-title {
  font-size: 1.5rem;
  margin-bottom: 20px;
  color: #ffffff;
}

.sidebar-list {
  list-style-type: none;
  padding: 0;
}

.sidebar-item {
  margin: 15px 0;
}

.sidebar-item a {
  color: #ffffff;
  text-decoration: none;
  padding: 10px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s;
}

.sidebar-item a:hover {
  background-color: #3b4a60;
}
</style>
